// extracted by css-extract-rspack-plugin
export default {"headerClassName":"src-domain-components-modal-screen-share-modalScreenShare-module__headerClassName-kCfJb5","confirmIcon":"src-domain-components-modal-screen-share-modalScreenShare-module__confirmIcon-FjbYkt"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"headerClassName\":\"src-domain-components-modal-screen-share-modalScreenShare-module__headerClassName-kCfJb5\",\"confirmIcon\":\"src-domain-components-modal-screen-share-modalScreenShare-module__confirmIcon-FjbYkt\"}";
        // 1793705032964
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  